const IMG = {
  performance:
    "https://images.unsplash.com/photo-1631376178637-392efc9e356b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxtb3RoZXJib2FyZCUyMG1hY3JvfGVufDB8fHx8MTc4ODIyODc4N3ww&ixlib=rb-4.1.0&q=85",
  gaming:
    "https://images.unsplash.com/photo-1619597455322-4fbbd820250a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxnYW1pbmclMjBwYyUyMHNldHVwJTIwZGFya3xlbnwwfHx8fDE3ODgyMjg3ODd8MA&ixlib=rb-4.1.0&q=85",
  price:
    "https://images.unsplash.com/photo-1762279388956-c1fc34cb1c08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxuZW9uJTIwY2hhcnR8ZW58MHx8fHwxNzg4MjI4Nzk1fDA&ixlib=rb-4.1.0&q=85",
  software:
    "https://images.unsplash.com/photo-1754039984985-ef607d80113a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxjb2RlJTIwc2NyZWVuJTIwbmVvbnxlbnwwfHx8fDE3ODgyMjg4MDF8MA&ixlib=rb-4.1.0&q=85",
  creative:
    "https://images.unsplash.com/photo-1502810190503-8303352d0dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMGRlc2lnbiUyMGRlc2t8ZW58MHx8fHwxNzg4MjI4Nzg4fDA&ixlib=rb-4.1.0&q=85",
  longevity:
    "https://images.unsplash.com/photo-1677022725616-91e41d36db21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwY29tcHV0ZXJ8ZW58MHx8fHwxNzg4MjI4Nzg3fDA&ixlib=rb-4.1.0&q=85",
};

export const POSTS = [
  {
    slug: "raw-performance-compared",
    title: "Raw Performance: Silicon vs. The Custom Build",
    category: "Performance",
    side: "win",
    image: IMG.performance,
    date: "July 2026",
    readTime: "8 min read",
    excerpt:
      "Apple's M-series chips rewrote the efficiency playbook. But a well-specced Windows tower still owns the peak-performance crown. We break down benchmarks, thermals, and what 'fast' actually means in 2026.",
    body: [
      {
        heading: "The efficiency revolution",
        text: "Apple's M-series silicon changed the conversation. Performance per watt is the metric Cupertino dominates: a MacBook Air does serious work on battery while staying silent and cool. For everyday computing — browsing, documents, video calls, photo editing — the Mac feels effortlessly quick and sips power doing it.",
      },
      {
        heading: "Where Windows still wins outright",
        text: "Peak performance is a different story. A desktop Windows PC with a high-wattage CPU and a discrete NVIDIA GPU will out-render, out-compile, and out-game any Mac at the same price. Liquid cooling, overclocking, and upgradeable parts mean the ceiling on a PC is simply higher — and you decide where it sits.",
      },
      {
        heading: "Thermals and throttling",
        text: "Macs are tuned for sustained silence, which means heavy multi-hour loads can pull clocks back. A gaming-tower PC with proper airflow holds boost clocks indefinitely. If your workload is bursty, both feel identical. If it is sustained — 3D rendering, large code builds, scientific computing — the PC's thermal headroom pays off.",
      },
      {
        heading: "The verdict",
        text: "For 90% of users, Apple silicon is more than enough and wonderfully efficient. For the 10% who push hardware to its limits — or want to choose their own components — Windows remains the performance king. Measure your actual workload before you measure your wallet.",
      },
    ],
  },
  {
    slug: "gaming-pc-vs-mac",
    title: "Gaming: The One Round That Isn't Close",
    category: "Gaming",
    side: "win",
    image: IMG.gaming,
    date: "July 2026",
    readTime: "7 min read",
    excerpt:
      "Ray tracing, high refresh rates, forty years of game libraries — Windows owns this category. But cloud gaming is quietly changing what a Mac can do. Here's the honest scorecard.",
    body: [
      {
        heading: "The library problem",
        text: "Steam's catalog on Windows dwarfs macOS by an order of magnitude. Most AAA titles ship Windows-first or Windows-only, anti-cheat systems often refuse to run on macOS, and mods are overwhelmingly PC-centric. If a game exists, it almost certainly runs on Windows. On Mac, you check a compatibility list first.",
      },
      {
        heading: "Hardware headroom",
        text: "Gaming is GPU-bound, and Windows PCs offer every GPU on the market — from budget cards to halo products drawing 450 watts. High-refresh 144Hz-to-360Hz monitors, ultrawides, and variable refresh rate support are plug-and-play. Apple has never targeted this buyer, and it shows.",
      },
      {
        heading: "The cloud gaming wildcard",
        text: "Services like GeForce NOW and Xbox Cloud Gaming run beautifully on a Mac, streaming Windows games from a data center. For casual players, this erases much of the gap. But it needs fast, stable internet, adds latency, and you'll never own the local copy.",
      },
      {
        heading: "The verdict",
        text: "If gaming matters to you even moderately, buy the Windows PC. It isn't a close call — it's the most one-sided round in this entire comparison. Macs are magnificent machines that happen to be mediocre game consoles.",
      },
    ],
  },
  {
    slug: "price-and-value-breakdown",
    title: "Price & Value: What a Dollar Buys You",
    category: "Value",
    side: "mac",
    image: IMG.price,
    date: "July 2026",
    readTime: "6 min read",
    excerpt:
      "A $700 Windows laptop and a $999 MacBook Air are not the same conversation. We compare sticker price, cost per year of use, and the resale curve nobody talks about.",
    body: [
      {
        heading: "Sticker price vs. real price",
        text: "Windows PCs span $300 budget boxes to $4,000 workstations. Macs start around $999 and climb steeply. On day one, Windows always wins on price — you can simply spend less. But sticker price is the least interesting number in this comparison.",
      },
      {
        heading: "Cost per year",
        text: "Macs routinely stay fast and supported for 7–10 years. Budget Windows laptops often feel tired by year four. Divide the purchase price by years of happy use and the Mac's premium shrinks dramatically — sometimes it disappears entirely.",
      },
      {
        heading: "The resale curve",
        text: "A three-year-old MacBook retains 50–60% of its value. A three-year-old Windows laptop is often worth a fraction of its price. If you sell or trade in when upgrading, the Mac's true cost of ownership is far lower than the receipt suggests.",
      },
      {
        heading: "The verdict",
        text: "Tight budget today? Windows, and don't feel bad about it. Thinking in 5-year spans with resale at the end? The Mac is frequently the cheaper machine. Value is a timeline, not a price tag.",
      },
    ],
  },
  {
    slug: "software-ecosystem-faceoff",
    title: "Software & Ecosystem: The Invisible Decider",
    category: "Software",
    side: "mac",
    image: IMG.software,
    date: "July 2026",
    readTime: "9 min read",
    excerpt:
      "You don't buy a computer — you buy into an ecosystem. AirDrop and iMessage versus the open, run-anything freedom of Windows. Which lock-in can you live with?",
    body: [
      {
        heading: "The Apple gravity well",
        text: "If you own an iPhone, the Mac pulls you in: AirDrop, universal clipboard, iMessage on your desktop, your watch unlocking your laptop, calls relayed through your machine. It's seamless to the point of feeling like magic — and it only works inside Apple's walls.",
      },
      {
        heading: "The Windows advantage: everything runs",
        text: "Windows runs essentially all desktop software ever written, including decades of business and industrial applications that power the world's offices. Enterprise tools, engineering software, niche utilities, legacy databases — if it exists, it runs on Windows. For developers, WSL brings a real Linux environment natively.",
      },
      {
        heading: "Quality of life details",
        text: "macOS is famously consistent: one settings app, predictable updates, no driver hunts. Windows offers more choice and more clutter — two settings apps, manufacturer bloatware, and update prompts at inconvenient moments. Power users forgive Windows everything; everyone else notices.",
      },
      {
        heading: "The verdict",
        text: "iPhone owner who values polish? The Mac ecosystem is a genuine quality-of-life upgrade. Work in enterprise software, engineering, or need something niche to run? Windows is the only door. Your software list decides this round before any benchmark does.",
      },
    ],
  },
  {
    slug: "creative-work-showdown",
    title: "Creative Work: Designers, Editors & Musicians Weigh In",
    category: "Creative",
    side: "mac",
    image: IMG.creative,
    date: "July 2026",
    readTime: "8 min read",
    excerpt:
      "Hollywood colorists, studio musicians, and design agencies kept the Mac alive through its darkest years. In 2026, is the creative crown still theirs — or has Windows caught up?",
    body: [
      {
        heading: "Why creatives chose Mac in the first place",
        text: "Color-accurate displays out of the box, Core Audio's low-latency sound stack, and a Unix foundation made the Mac the default creative machine for decades. Fonts rendered the way print shops expected. That institutional memory still shapes studios today.",
      },
      {
        heading: "Where Mac still leads",
        text: "Music production (Logic Pro is Mac-only and beloved), color grading with ProRes acceleration baked into the silicon, and any workflow living in the Apple media ecosystem. MacBook screens remain reference-quality, and the trackpad is still the best ever shipped.",
      },
      {
        heading: "Where Windows caught up — and passed",
        text: "Adobe's suite runs identically on both platforms now. For 3D work — Blender, Cinema 4D, Unreal Engine — NVIDIA's CUDA ecosystem makes Windows the standard. DaVinci Resolve renders faster on a GPU-heavy PC. Animation and VFX studios increasingly render on Windows iron.",
      },
      {
        heading: "The verdict",
        text: "Photography, music, and video editing? Mac, comfortably. 3D, motion graphics, and game-engine work? Windows with a serious GPU. The creative monolith is gone — pick your discipline, then your machine.",
      },
    ],
  },
  {
    slug: "longevity-and-repairability",
    title: "Longevity & Repair: Which Machine Grows Old Gracefully?",
    category: "Ownership",
    side: "win",
    image: IMG.longevity,
    date: "July 2026",
    readTime: "7 min read",
    excerpt:
      "Ten-year-old Macs still browse the web beautifully. Ten-year-old PCs have new graphics cards and twice the RAM. Two very different philosophies of growing old.",
    body: [
      {
        heading: "The sealed vault vs. the open chassis",
        text: "Modern Macs are sealed: RAM and storage are soldered at purchase, forever. What you buy is what you keep. A desktop PC is the opposite — swap the GPU in year three, double the RAM in year four, replace any part that fails with a screwdriver and an afternoon.",
      },
      {
        heading: "Software support timelines",
        text: "Apple supports Macs with macOS updates for roughly 7–8 years from release — long, predictable, and automatic. Windows 11 runs on a huge range of older hardware, and individual components can be refreshed to keep pace. Both ecosystems age well, just differently.",
      },
      {
        heading: "Repair economics",
        text: "A dead Mac logic board can cost more than the machine's value; AppleCare+ is close to mandatory insurance. PC parts are commodities — a failed power supply or SSD costs little and takes minutes to replace. Independent repair shops can fix nearly any PC; Macs increasingly require Apple's own channels.",
      },
      {
        heading: "The verdict",
        text: "The Mac ages like a well-built appliance: unchanged, reliable, eventually replaced whole. The PC ages like a house: renovated room by room, indefinitely. Buy the Mac for graceful aging, the PC for immortality through upgrades.",
      },
    ],
  },
];

export const FAQS = [
  {
    q: "Is a Mac or a Windows PC better for students?",
    a: "For most students, a MacBook Air is the safer pick: all-day battery, silent operation, and 7+ years of software support. But students in engineering, architecture, or game development should choose Windows — much of the required software (AutoCAD, SolidWorks, many engineering tools) is Windows-only or runs best there.",
  },
  {
    q: "Can a Mac run Windows programs?",
    a: "Not natively. Options include virtualization apps like Parallels (runs Windows inside macOS, with a performance cost), cloud PCs, or compatibility layers for select apps. Many professional Windows applications — especially those needing specific drivers or anti-cheat — will not work. If your workflow depends on a Windows-only app, buy the Windows PC.",
  },
  {
    q: "Which is better for gaming, Mac or PC?",
    a: "Windows, decisively. It has the full game library, every GPU on the market, high-refresh display support, and mod communities. Macs can game via cloud services like GeForce NOW, but for local gaming a Windows PC is the only serious choice.",
  },
  {
    q: "Do Macs really last longer than PCs?",
    a: "Macs typically receive 7–8 years of macOS updates and hold their speed well because hardware and software are designed together. Windows PCs vary by build quality — a cheap laptop may struggle by year four, but a good desktop PC can be upgraded indefinitely with new parts. Macs age gracefully; PCs age renewably.",
  },
  {
    q: "Why do Macs hold their resale value better?",
    a: "Three factors: long software support keeps old Macs useful, build quality survives years of use, and demand stays high in the second-hand market. A three-year-old MacBook commonly resells for 50–60% of its original price, while most Windows laptops depreciate far faster.",
  },
  {
    q: "Is macOS safer than Windows?",
    a: "macOS benefits from a smaller malware target surface and tight default restrictions, so the average Mac user encounters fewer threats. Windows 11 has closed much of the gap with built-in security (Defender, SmartScreen, secure boot), but its huge market share keeps it the primary target. Safe habits matter more than the platform.",
  },
  {
    q: "Which is better for video editing and design?",
    a: "Macs excel at video editing — ProRes acceleration in Apple silicon and apps like Final Cut Pro make them studio favorites. For 3D rendering, motion graphics, and Unreal Engine work, a Windows PC with an NVIDIA GPU is the industry standard. Photography and design are excellent on both.",
  },
  {
    q: "Can I switch from Windows to Mac (or back) easily?",
    a: "Yes — files, photos, and cloud accounts transfer easily with built-in migration tools on both platforms. The adjustment is mostly muscle memory: keyboard shortcuts, window controls, and file management differ. Budget a week of mild frustration; most switchers never look back either way.",
  },
];

export const ANTIVIRUS_PRODUCTS = [
  {
    name: "Microsoft Defender",
    price: "Free (built into Windows)",
    protection: "Excellent — consistently near-perfect scores in independent lab tests",
    impact: "Low — already integrated into Windows 11",
    platforms: "Windows",
    bestFor: "Most Windows users, most of the time",
    verdict: "The default answer. Free, silent, and genuinely good. Start here before spending anything.",
    pick: true,
  },
  {
    name: "Bitdefender Total Security",
    price: "~$40–60/yr (5 devices)",
    protection: "Outstanding — perennial lab-test leader",
    impact: "Very low — among the lightest paid suites",
    platforms: "Windows, macOS, Android, iOS",
    bestFor: "Households wanting maximum protection with minimal fuss",
    verdict: "The best paid suite for most people. Top scores, light footprint, fair multi-device pricing.",
    pick: true,
  },
  {
    name: "Norton 360 Deluxe",
    price: "~$50/yr (5 devices)",
    protection: "Outstanding — long-established, consistently top-tier",
    impact: "Low-to-moderate — heavier than Bitdefender, plus upsell popups",
    platforms: "Windows, macOS, Android, iOS",
    bestFor: "Users who want an all-in-one bundle (VPN, password manager, cloud backup)",
    verdict: "A genuine security bundle, but the constant upgrade nags cost it the top spot.",
    pick: false,
  },
  {
    name: "Malwarebytes Premium",
    price: "~$45/yr (5 devices)",
    protection: "Very good — superb at cleanup, slightly behind suites on prevention",
    impact: "Very low — famously lightweight",
    platforms: "Windows, macOS, Android, iOS",
    bestFor: "Minimalists and as a second-opinion scanner alongside Defender",
    verdict: "The best 'lean' option. Not a full suite — no firewall, no parental controls — and proud of it.",
    pick: false,
  },
  {
    name: "ESET Home Security",
    price: "~$50/yr (3 devices)",
    protection: "Excellent — deep configurability loved by power users",
    impact: "Very low — one of the lightest engines available",
    platforms: "Windows, macOS, Android",
    bestFor: "Enthusiasts who want granular control over every scan and rule",
    verdict: "The technician's choice. Dense settings, brilliant engine, zero hand-holding.",
    pick: false,
  },
  {
    name: "Avast One / AVG",
    price: "Free tier; ~$50/yr paid",
    protection: "Very good — solid engine, shared across both brands",
    impact: "Moderate — free tier pushes frequent upgrade prompts",
    platforms: "Windows, macOS, Android, iOS",
    bestFor: "Budget users who want a free tier with extras like a basic VPN",
    verdict: "Capable, but the free version's constant upselling and past data-privacy controversy hold it back.",
    pick: false,
  },
  {
    name: "Kaspersky Standard",
    price: "~$40/yr (3 devices)",
    protection: "Outstanding — historically elite detection rates",
    impact: "Low",
    platforms: "Windows, macOS, Android, iOS",
    bestFor: "Not available for sale in the US — banned since 2024",
    verdict: "Technically excellent, geopolitically complicated. Banned on US government systems and from US sale; existing users were migrated off. We can't recommend it to American readers.",
    pick: false,
  },
];

export const ANTIVIRUS_ROWS = [
  { label: "Best free option", detail: "Microsoft Defender — already on your Windows PC, near-perfect lab scores" },
  { label: "Best paid suite", detail: "Bitdefender Total Security — top protection, lightest touch, fair price" },
  { label: "Best for power users", detail: "ESET — unmatched configurability and a featherweight engine" },
  { label: "Best bundle", detail: "Norton 360 — VPN, password manager and cloud backup included, if you tolerate the nags" },
  { label: "Best lightweight", detail: "Malwarebytes — fast, quiet, pairs well with Defender" },
  { label: "Mac protection", detail: "Bitdefender or Malwarebytes for macOS — Macs need less, not zero" },
];

export const ANTIVIRUS_FAQS = [
  {
    q: "Is Windows' built-in antivirus good enough in 2026?",
    a: "For most people, yes. Microsoft Defender now scores near the top of independent lab tests (AV-TEST, AV-Comparatives), updates automatically, and costs nothing. Paid suites add extras — VPNs, password managers, cross-device coverage, better phishing filters — but the core protection gap has essentially closed.",
  },
  {
    q: "Do Macs need antivirus software?",
    a: "macOS has strong built-in defenses (XProtect, Gatekeeper, notarization), and Mac malware remains rarer than Windows malware. But 'rarer' isn't 'none' — adware and phishing target Mac users constantly. If you download software from outside the App Store or handle sensitive work, a light tool like Malwarebytes for Mac is cheap insurance.",
  },
  {
    q: "Will antivirus slow down my computer?",
    a: "Modern engines are remarkably light — Bitdefender, ESET, and Defender have near-imperceptible impact on recent hardware. Slowdowns mostly come from running two antivirus products simultaneously (never do this) or from older machines running heavy legacy suites.",
  },
  {
    q: "Free vs paid antivirus — what's the real difference?",
    a: "Core malware detection is often identical between a company's free and paid tiers. What you pay for: ransomware rollback, phishing/web protection, firewalls, parental controls, VPNs, multi-device licenses, and actual customer support. If you only need detection, free is fine.",
  },
  {
    q: "What happened to Kaspersky?",
    a: "In 2024 the US government banned Kaspersky software sales and updates over national-security concerns, and existing US installations were automatically migrated to a partner product. Outside the US it remains available and technically excellent — but we can't recommend software American readers can't legally buy or update.",
  },
  {
    q: "Is one antivirus enough, or should I layer tools?",
    a: "One real-time antivirus only — two running together cause conflicts and slowdowns. You can safely add an on-demand second-opinion scanner (like the free Malwarebytes scan) that you run manually. Beyond software: a password manager, two-factor authentication, and prompt updates protect you more than any second engine.",
  },
];

export const COMPARISON_ROWS = [
  { label: "Starting price", win: "$300 – $500 entry", mac: "$999 (MacBook Air)" },
  { label: "Peak performance", win: "Unlimited — custom GPUs, overclocking", mac: "Excellent efficiency, capped ceiling" },
  { label: "Gaming library", win: "Entire PC catalog + mods", mac: "Limited native + cloud gaming" },
  { label: "Software support", win: "Varies by OEM, hardware refreshable", mac: "~7–8 years of macOS updates" },
  { label: "Repairability", win: "Fully modular (desktops)", mac: "Sealed — soldered RAM/storage" },
  { label: "Resale after 3 years", win: "20–35% of original price", mac: "50–60% of original price" },
  { label: "Ecosystem perks", win: "Runs everything, open platform", mac: "AirDrop, iMessage, iPhone continuity" },
  { label: "Best for", win: "Gamers, engineers, tinkerers, budgets", mac: "Creatives, students, iPhone owners" },
];

export const STATIC_PAGES = {
  about: {
    title: "About onlyreviews.blog",
    kicker: "The Publication",
    sections: [
      {
        heading: "What we do",
        text: "onlyreviews.blog is an independent editorial publication dedicated to one question: Windows PC or Mac? We publish in-depth, hands-on comparisons across performance, gaming, value, software, creative work, and long-term ownership — written for real buyers, not spec-sheet collectors.",
      },
      {
        heading: "Our editorial stance",
        text: "We are not affiliated with Microsoft, Apple, or any hardware manufacturer. Every article states a clear verdict because fence-sitting helps nobody. Where a category has no winner, we say that too. Our opinions are based on publicly available specifications, industry reporting, and hands-on experience with both platforms.",
      },
      {
        heading: "How we make money",
        text: "This site is currently supported by display advertising. Ads never influence our verdicts. If that ever changes, this page will say so first.",
      },
    ],
  },
  "privacy-policy": {
    title: "Privacy Policy",
    kicker: "Your Data",
    sections: [
      {
        heading: "What we collect",
        text: "onlyreviews.blog is a read-only publication. We do not operate accounts, comment systems, or newsletters, and we do not collect names, email addresses, or payment information.",
      },
      {
        heading: "Cookies & analytics",
        text: "We may use privacy-respecting analytics to understand which articles are read, and advertising partners (such as Google AdSense) may set cookies to serve and measure ads. You can control personalized advertising through your Google Ads Settings and your browser's cookie controls.",
      },
      {
        heading: "Third-party advertising",
        text: "Third-party vendors, including Google, use cookies to serve ads based on your prior visits to this and other websites. Google's use of advertising cookies enables it and its partners to serve ads based on your visits. You may opt out of personalized advertising by visiting Ads Settings (adssettings.google.com).",
      },
      {
        heading: "Contact",
        text: "Questions about this policy? Reach us via the details on our Contact page. This policy was last updated in July 2026.",
      },
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    kicker: "The Fine Print",
    sections: [
      {
        heading: "Editorial opinion",
        text: "All articles on onlyreviews.blog represent the editorial opinions of our writers based on publicly available information, published benchmarks, and hands-on experience. Specifications, prices, and software support policies change frequently — always verify details with the manufacturer before purchasing.",
      },
      {
        heading: "Trademarks",
        text: "Windows and Microsoft are trademarks of the Microsoft group of companies. Mac, macOS, MacBook, iMac, and Apple are trademarks of Apple Inc. onlyreviews.blog is not affiliated with, endorsed by, or sponsored by either company. All trademarks are used for identification and comparison purposes only.",
      },
      {
        heading: "No professional advice",
        text: "Nothing on this site constitutes professional purchasing, financial, or technical advice. Your ideal computer depends on your specific workload, budget, and software requirements. When in doubt, list the apps you need to run first — the platform usually chooses itself.",
      },
    ],
  },
  contact: {
    title: "Contact",
    kicker: "Say Hello",
    phone: "+1 888-499-9335",
    phoneHref: "tel:+18884999335",
    sections: [
      {
        heading: "Call us",
        text: "The fastest way to reach the onlyreviews.blog team is by phone at +1 888-499-9335. Lines are open Monday to Friday, 9am–6pm ET. Whether it's a correction, a comparison request, or an advertising inquiry — start here.",
      },
      {
        heading: "Editorial & corrections",
        text: "Prefer writing? Spotted an error in a comparison, or have a topic you want us to cover next? Write to the editorial desk at editorial@onlyreviews.blog — we read everything and correct mistakes promptly and publicly.",
      },
      {
        heading: "Advertising inquiries",
        text: "For advertising and partnership inquiries, contact ads@onlyreviews.blog or call +1 888-499-9335. Please note that advertising never influences editorial verdicts, and sponsored placements are always labeled.",
      },
      {
        heading: "Response time",
        text: "We're a small team. Phone calls are answered during business hours; emails get a reply within 2–3 business days. For urgent corrections to published facts, mark your subject line with [CORRECTION] and it goes to the top of the pile.",
      },
    ],
  },
};
